__turbopack_context__.v({
  "className": "geist_3057a15e-module__mmrLSa__className",
});
